import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getPostDataCancelToken,
    getPostData,
    resetPublicView } from '../../../actions/publicView/view';
import DefaultCoverPhoto from '../../../assets/images/profile/view/cover-page.png';
import Avatar from '../../../components/user/Avatar';
import { decodeString,
    getTwoDigits } from '../../../utils/helper';
import LocationIcon from '../../../assets/images/profile/view/map-point-pointer.svg';
import LinkIconEmpty from '../../../assets/images/profile/view/link-empty.svg';
import ReadMoreText from '../../loggedIn/Feed/common/ReadMoreText';
import ChevronDown from '../../../assets/images/chevrons/chevron_down_black.png';
import DetailBlock from '../../loggedIn/Company/DetailBlock';
import { months } from '../../../utils/commonVariables';
import LoginForm from '../Login/LoginForm';
import { miscLinks } from '../../../utils/internalLinks';
import UserName from '../../../components/profile/UserName';
import SeoHeadMeta from '../../../components/misc/SeoHeadMeta';

function CompanyView(props) {
    const [viewData, setViewData] = useState(null),
        [showLoginForm, setShowLoginForm] = useState(false);
    const _renderMonth = (val) => {
        try {
            return months.filter(month => month.numeric === getTwoDigits(parseInt(val)))[0].fullName
        } catch {
            return ''
        }
    }
    useEffect(() => {
        props.getPostData('company', props.match.params.id)
        .then(res => {
            if (!res) {
                props.history.replace(miscLinks.notFound);
            }
        });
        return function() {
            if (getPostDataCancelToken) getPostDataCancelToken();
            props.resetPublicView();
        }
    }, [props.match.params.id]);
    useEffect(() => {
        setViewData(props.publicView.viewData);
    }, [props.publicView]);
    if (!viewData) return <div className="container profile-view profile-view--with-height">
        <div className="profile-view__details profile-view__details--no-margin">
            Fetching...
        </div>
    </div>;
    const { company,
        seoTags } = viewData,
        imageToShow = company.logo_meta
        && JSON.parse(company.logo_meta)
        && JSON.parse(company.logo_meta).original_photo
        ? JSON.parse(company.logo_meta).original_photo
        : '',
        heroImageToShow = company.hero_image_meta
            && JSON.parse(company.hero_image_meta)
            && JSON.parse(company.hero_image_meta).original_photo
            ? JSON.parse(company.hero_image_meta).original_photo
            : company.heroImageUrl
            ? company.heroImageUrl
            : '';
    return (<div className="container profile-view">
        { seoTags
            && seoTags.title
            && <SeoHeadMeta title={seoTags.title}>
                <title>{decodeString(seoTags.title)}</title>
            </SeoHeadMeta>}
        <div className="profile-view__background-container">
            <div className="profile-view__background-image__container">
                <img alt="background"
                    src={heroImageToShow || DefaultCoverPhoto}
                    className="profile-view__background-image"/>
            </div>
        </div>
        <div className="profile-view__details">
            <div className="profile-view__details__image__container company-profile-image">
                <Avatar alt={company.name}
                    isCompany={true}
                    className="profile-view__details__image"
                    src={imageToShow} />
            </div>
            <div className="profile-view__details__block">
                <div className="profile-view__details__block__header">
                    <h1 className="profile-view__details__block__name">
                    <UserName isVerified={!!company.verified}
                        width={20}
                        height={20}
                        name={company.name} />
                    </h1>
                    <div className="profile-view__details__block__header__action">
                        <button onClick={() => setShowLoginForm(true)} className="profile-view__details__block__follow-btn">
                            <span className="profile-view__details__block__follow-btn__text">+ Follow</span>
                        </button>
                    </div>
                </div>
                <div className="profile-view__details__block__follow__block">
                    <span onClick={() => setShowLoginForm(true)} className="profile-view__details__block__follow__text profile-view__details__block__follow__text--link">
                        <span className="profile-view__details__block__follow__text">{company.followersCount}</span>
                        <span className="profile-view__details__block__follow__text profile-view__details__block__follow__text--secondary">{company.followersCount === 1 ? 'Follower' : 'Followers'}</span>
                    </span>
                </div>
                {
                    company.tagline && (<div className="profile-view__details__block__info">
                        <p className="profile-view__details__block__info__text">{company.tagline}</p>
                    </div>)
                }
                {
                    company.city && (<div className="profile-view__details__block__info">
                        <img
                            alt="add location"
                            src={LocationIcon}
                            className="profile-view__details__block__info__image"/>
                        <p className="profile-view__details__block__info__text">{company.city}</p>
                    </div>)
                }
                {
                    company.websites && (<div className="profile-view__details__block__info">
                        <img alt="link placeholder"
                            src={LinkIconEmpty}
                            className="profile-view__details__block__info__image"/>
                        <a href={company.websites}
                            target="_blank"
                            rel="noreferrer noopener"
                            className="profile-view__details__block__info__text profile-view__details__block__info__text--link">{company.websites}</a>
                    </div>)
                }
            </div>
            {
                company.about && (<div className="profile-view__details__block"><div className="profile-view__details__block__about">
                    <p className="profile-view__details__block__about__title">About</p>
                    <div className="profile-view__details__block__about__description">
                        { company.about && <ReadMoreText text={company.about} /> }
                    </div>
                </div></div>)
            }
            {
                ((company.status && company.status.name)
                || (company.type && company.type.name)
                || company.established_on
                || company.employeeCountValue
                || company.speciality
                || company.email
                || company.affiliations)
                && (<div className="profile-view__details__block__professional">
                    {
                        (company.status && company.status.name)
                        && (<DetailBlock
                            title='Current Status'
                            value={company.status ? company.status.name : ''}
                        /> )
                    }
                    {
                        (company.type && company.type.name)
                        && (<DetailBlock
                            title='Type'
                            value={company.type ? company.type.name : ''} />)
                    }
                    {
                        (company.established_on)
                        && (<DetailBlock
                            title='Established'
                            value={company.established_on ? `${company.established_on.split('-')[0]} ${_renderMonth(company.established_on.split('-')[1])} ${company.established_on.split('-')[2]}`: ''} />)
                    }
                    {
                        company.employeeCountValue
                        && (<DetailBlock
                            title='Number of Employees'
                            value={company.employeeCountValue || ''} />)
                    }
                    {
                        (company.speciality)
                        && (<DetailBlock
                            title='Specializes in'
                            value={company.speciality ? decodeString(company.speciality).split(',').join(', ') : ''} />)
                    }
                    {
                        (company.email)
                        && (<DetailBlock
                            title='Email'
                            value={company.email || ''} />)
                    }
                    {
                        (company.affiliations)
                        && ( <DetailBlock
                            title='Affiliations'
                            value={company.affiliations || ''} />)
                    }
                </div>)
            }
            <button onClick={() => setShowLoginForm(true)} className="profile-view__show-more">Show More
                <img src={ChevronDown} alt="show more" />
            </button>
        </div>
        { showLoginForm && <LoginForm shouldOnlyToggle={true}
            toggleLoginForm={() => setShowLoginForm(false)} /> }
    </div>);
}

const mapDispatchToProps = {
    resetPublicView,
    getPostData
}

function mapStateToProps(state) {
    return {
        publicView: state.publicView
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyView);